<template>
  <div>
      <HeadDetailsGama  :btnCanceSave="true" :titleHead="'Detalhe do Empreendimento'"></HeadDetailsGama>
       <div  id="body-details" class="mt-4 ml-2">
            <Towerscourtacording :dataEnterprise="dataTowers" v-on:load="loadAll" :dataType="dataType" :dataGroup="dataGroup" :enumStatus="enumStatus" :dataUnity="dataUnity" v-for="(dtgr, i) in dataGroup" :key="i" :i="i" :dtgr="dtgr"></Towerscourtacording>
       </div>
  </div>
</template>

<script>
import Towerscourt from './towerscourt'
export default Towerscourt
</script>

<style scoped>

.colapseGreen{
    background-color: #008148;
    color: white;
    font-size: 20px;
    font-weight: bold;
}
.arrow-angel-white{
    color: white;
    font-size: 35px;
    padding-right: 20px;
    padding-bottom: 5px;
}
.row-colapse-green{
    display: flex;
    align-content: center;
    justify-content: space-between;
}
.pencil-edit{
    font-size: 20px;
    color: green;
    cursor: pointer;
}
.info-colapse-green{
    margin: 0px;
}
.title-colapse-green{
  font-size: 20px;
  color: #008148;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/enterprise/components/towerscourt/towerscourt.vue